export { default } from './New';



// WEBPACK FOOTER //
// ./src/components/templates/New/index.js